// Brands list endpoint. Relative to the `ops` base URL, so it is used with
// useAxios({ base: "ops" }) — never inline the path at the call site.
export const BRANDS_ENDPOINT = "accounts/v1";

export const BRANDS_DEFAULT_LIMIT = 10;

// Static list: the API exposes no country lookup, so the filter is a plain
// Select over the countries Nook Pay onboards brands from rather than a
// URL-driven async select.
export const COUNTRY_OPTIONS = ["India", "United States", "United Kingdom", "Singapore", "United Arab Emirates", "Australia", "Canada"];
